<template>
  <div v-if="comments.length" class="recruitment-board-comments-preview">
    <span class="recruitment-board-comments-preview__label">{{ $t("recruitment.details.recentComments") }}</span>
    <div
      v-for="comment in comments"
      :key="comment.id"
      class="recruitment-board-comments-preview__item"
      :title="comment.Comment"
    >
      <v-icon size="13" class="recruitment-board-comments-preview__icon">mdi-comment-text-outline</v-icon>
      <span>{{ comment.Comment }}</span>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "RecruitmentBoardCommentsPreview",
  props: {
    comments: { type: Array, default: () => [] },
  },
});
</script>

<style scoped>
.recruitment-board-comments-preview {
  margin-top: 8px;
  padding-top: 7px;
  border-top: 1px solid rgba(var(--v-theme-on-surface), 0.06);
}

.recruitment-board-comments-preview__label {
  display: block;
  margin-bottom: 4px;
  font-size: 0.72rem;
  font-weight: 600;
  color: rgba(var(--v-theme-on-surface), 0.58);
}

.recruitment-board-comments-preview__item {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  font-size: 0.78rem;
  line-height: 1.45;
  color: rgba(var(--v-theme-on-surface), 0.7);
}

.recruitment-board-comments-preview__icon {
  opacity: 0.6;
  flex-shrink: 0;
}

.recruitment-board-comments-preview__item span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
